// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "GalleryImageElement" : chunkId) + "." + {"494":"7e22d663ff9fdfad","502":"1f2c22a09bc1bbfa","763":"ea057ed3ac16a7d5"}[chunkId] + ".js";
};